export type ReportItem = {
  _id?: string;
  firstname?: string | null;
  lastname?: string | null;
  fullName?: string;
  phone?: string;
  source?: string;
  created_time?: string;
  agentShare?: string;
  agentShareName?: string;
  agentid?: string;
  agentName?: string;
  agentLeaderName?: string;
  leaderCode?: string;
  unit?: string;
  agentOfficeCode?: string;
  callStatus?: boolean;
  calledDate?: string;
  timeContact?: string;
  appointmentSetTime?: string;
  attendedMeetingTime?: string;
  checkinPocTime?: string;
  checkinBopTime?: string;
  nbriTime?: string;
  bop1_1checkinTime?: string;
};

export type ReportListParams = {
  createdAtFrom: Date | null;
  createdAtTo: Date | null;
  agentCode: string;
  leaderCode: string;
  unit: string;
  candidateName: string;
  phone: string;
  source: string;
  page: number;
  limit: number;
};

export const SOURCE_OPTIONS = [
  { displayName: 'All', value: '' },
  { displayName: 'Sự kiện tuyển dụng', value: 'recruitmentEvent' },
  { displayName: 'Khảo sát', value: 'survey' },
  { displayName: 'Công ty', value: 'company' },
  { displayName: 'TVV Giới thiệu', value: 'referral' },
];
